import React from 'react';
import Modal from './Modal';

/**
 * Confirmation dialog built on Modal. Replaces window.confirm() calls.
 *
 * Props:
 *   isOpen       {boolean}
 *   title        {string}
 *   message      {string|ReactNode}
 *   confirmLabel {string}             default 'Confirm'
 *   variant      {'danger'|'primary'} default 'danger'
 *   loading      {boolean}            disables buttons while in flight
 *   onConfirm    {function}
 *   onCancel     {function}
 */
const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  variant = 'danger',
  loading = false,
  onConfirm,
  onCancel,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    title={title}
    footer={
      <>
        <button
          onClick={onCancel}
          disabled={loading}
          className="btn-secondary disabled:opacity-50"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          disabled={loading}
          className={`${variant === 'danger' ? 'btn-danger' : 'btn-primary'} disabled:opacity-50`}
        >
          {loading ? 'Please wait…' : confirmLabel}
        </button>
      </>
    }
  >
    <p className="text-gray-600">{message}</p>
  </Modal>
);

export default ConfirmDialog;
